import StoryCommentAuthorName from "%/dynamic-component-editor/standard-components/story-comment/StoryCommentAuthorName.vue";
import StoryCommentCreated from "%/dynamic-component-editor/standard-components/story-comment/StoryCommentCreated.vue";
import StoryCommentMessage from "%/dynamic-component-editor/standard-components/story-comment/StoryCommentMessage.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyStoryComment extends LegacyEntity {
  get elements() {
    return {
      StoryCommentAuthorName,
      StoryCommentCreated,
      StoryCommentMessage,
    };
  }
}
